module.exports = __webpack_public_path__ + "static/media/rentalpassword.78b88039.png";